import {lazyComponent} from 'coreUtils/adapters/lazy';

const AddPaymentCardPopup = lazyComponent(() => import('./AddPaymentCardPopup'));

export {AddPaymentCardPopup as default};
